module.exports = __webpack_public_path__ + "img/timeline_temperature.1a450d04.svg";